import { Loading } from '../../components/Loading';
import { FormVariant } from '../../forms';
import { MissionQuotationInfoForm } from '../../forms/MissionQuotationInfo';

import { useInitHandler } from './hooks/useInitHandler.hook';

export const MissionQuotationInit = () => {
  const { handleSuccess, isSubmitting, onInit } = useInitHandler();

  return (
    <>
      {/* eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion */}
      {!!isSubmitting && <Loading />}
      <MissionQuotationInfoForm
        formVariant={FormVariant.Creation}
        onSuccess={handleSuccess}
        showCancelButton={false}
        submitLabel="Initialiser"
        useSubmitFactory={onInit}
      />
    </>
  );
};
